import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Box, Typography, Button, Grid } from '@mui/material'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import { registerInterest } from 'features/fbt-submissions/actions'

const PromotionForm = () => {
  const dispatch = useDispatch()

  const [values, setValues] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    organisation: ''
  })

  const onInputChange = ({ target: { name, value } }) =>
    setValues({ ...values, [name]: value, })

  const onRegisterInterest = () => {
    console.log('[onRegisterInterest]', values)
    dispatch(registerInterest(values))
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={6}>
        <Box
          sx={{
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center'
          }}>
          <Typography
            sx={{
              maxWidth: 510,
              color: '#FFF',
              textAlign: 'center',
              padding: 2,
              paddingRight: { xs: 1, sm: 3, md: 4 },
              paddingLeft: { xs: 1, sm: 3, md: 4 },
              paddingBottom: 0,
            }}
            variant="body1">
            You are not currently subscribed to TFM&apos;s FBT reporting.<br />
            If you would like to learn more about how you can get your organisation registered for this service, sign up now.
          </Typography>
        </Box>
        <Box
          sx={{
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center'
          }}>
          <Box
            component="img"
            src="/static/images/marketing/car.png"
            alt="car"
            sx={{
              height: 350,
              width: 'auto',
              '@media (max-width:900px)': {
                height: 225,
              },
              '@media (max-width:600px)': {
                height: 200,
              },
              '@media (max-width:0px)': {
                height: 180,
              },
            }}/>
        </Box>
      </Grid>

      <Grid
        sx={{
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center'
        }}
        item xs={12} sm={6} md={6}>
        <ValidatorForm
          sx={{
            maxWidth: 510
          }}
          autoComplete="off" noValidate onSubmit={onRegisterInterest}>
          <Typography
            sx={{
              color: '#FFF'
            }}
            variant="h4">
            Register Your Interest
          </Typography>
          {[
            {
              label: 'FIRST NAME',
              key: 'firstName',
              validators: ['required'],
              error: ['This field is required'],
              maxLength: 50,
            },
            {
              label: 'LAST NAME',
              key: 'lastName',
              validators: ['required'],
              error: ['This field is required'],
              maxLength: 50,
            },
            {
              label: 'EMAIL',
              key: 'email',
              validators: ['required', 'isEmail'],
              error: ['This field is required', 'Must be a valid email'],
              maxLength: 100,
            },
            {
              label: 'MOBILE',
              key: 'mobile',
              validators: ['required', 'isNumber'],
              error: ['This field is required', 'Must be a valid mobile number'],
              maxLength: 50,
            },
            {
              label: 'ORGANISATION',
              key: 'organisation',
              validators: ['required'],
              error: ['This field is required'],
              maxLength: 60,
            },
          ].map(({ label, key, validators, error, maxLength }) => (
            <TextValidator
              key={`${key}-field`}
              InputProps={{ sx: { color: '#FFF' } }}
              inputProps={{ maxLength }}
              InputLabelProps={{ sx: { color: '#FFF' } }}
              style={{ marginTop: 20 }}
              sx={{
                marginTop: 2,
                '& label.Mui-focused': { color: '#FFF' },
                '& .MuiInput-underline:after': { borderBottomColor: '#FFF' },
                '& .MuiOutlinedInput-root': {
                  '& fieldset': { borderColor: '#FFF' },
                  '&:hover fieldset': { borderColor: '#FFF' },
                  '&.Mui-focused fieldset': { borderColor: '#FFF' },
                },
              }}
              fullWidth
              size="small"
              label={label}
              name={key}
              required
              value={values?.[key] || ''}
              variant="outlined"
              validators={validators}
              errorMessages={error}
              onChange={onInputChange}/>
          ))}

          <Box
            sx={{
              paddingY: 2
            }}>
            <Button
              sx={{
                maxWidth: 250,
                '@media (max-width:900px)': {
                  maxWidth: '100%',
                },
              }}
              fullWidth
              type="submit"
              color="primary"
              variant="contained">
              REGISTER YOUR INTEREST
            </Button>
          </Box>
        </ValidatorForm>
      </Grid>
    </Grid>
  )
}

export default PromotionForm
